module.exports = __webpack_public_path__ + "img/icon_couple.6961495b.svg";